import { MiliSeconds } from "./types";

export function delay(ms: MiliSeconds): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
